var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative vh-100 w-100 dark-gray",class:{
    'brand-lh': _vm.brand === 'lh',
    'brand-lq': _vm.brand === 'lq'
  },attrs:{"id":"app"}},[(_vm.brand && _vm.$route.path !== '/')?_c('Logo',{attrs:{"brand":_vm.brand}}):_vm._e(),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('transition',{attrs:{"enter-active-class":"fade-in-bottom","leave-to-class":"fade"}},[(_vm.showNav)?_c('NavPrimary'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }